import {
  DASHBOARD_LOADED,
  USER_LOGGED_OUT,
  USER_NOT_LOGGED_IN,
  SET_ACTIVE_CASE,
  REFERRALS_LOADING,
  REFERRALS_LOADED,
  REFERRALS_LOAD_FAILED,
} from "../actions/dashboardActions";

// The estate agent Referrals tab is fetched separately from the dashboard, so it has its own
// state: DASHBOARD_LOADED only ever picks session and cases off its payload. Loaded data is kept
// across a reload so reopening the tab shows the last list while the fresh one arrives.
const initialReferralsState = {
  status: "idle", // idle | loading | loaded | failed
  data: null,
};

const initialDashboardState = {
  session: null,
  cases: null,
  lastActiveCaseRef: null,
  lastActiveCaseScreen: null,
  referrals: initialReferralsState,
};

export function dashboardState(state = initialDashboardState, action) {
  switch (action.type) {
    case DASHBOARD_LOADED:
      return {
        ...state,
        session: action.dashboardData.session,
        cases: action.dashboardData.cases,
      };
    case REFERRALS_LOADING:
      return {
        ...state,
        referrals: { ...state.referrals, status: "loading" },
      };
    case REFERRALS_LOADED:
      return {
        ...state,
        referrals: { status: "loaded", data: action.referralsData },
      };
    case REFERRALS_LOAD_FAILED:
      return {
        ...state,
        referrals: { ...state.referrals, status: "failed" },
      };
    case SET_ACTIVE_CASE: {
      const newState = {
        ...state,
        lastActiveCaseRef: action.caseRef,
      };
      if (!!action.caseScreen) {
        newState.lastActiveCaseScreen = action.caseScreen;
      }
      return newState;
    }
    case USER_LOGGED_OUT:
      return {
        ...initialDashboardState,
      };
    default:
      return state;
  }
}

const initialLoginState = {
  showLogin: false,
};

export function loginState(state = initialLoginState, action) {
  switch (action.type) {
    case USER_NOT_LOGGED_IN:
      return {
        ...state,
        showLogin: true,
      };
    case USER_LOGGED_OUT:
      return {
        ...initialLoginState,
      };
    default:
      return state;
  }
}
